// extracted by mini-css-extract-plugin
module.exports = {"rootButton":"ButtonCard_rootButton__3kv_3","root":"ButtonCard_root__2HPrv","text":"ButtonCard_text__3zIV7"};